import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CurrentUser } from '@/shared/api/types';

interface AuthState {
  accessToken: string | null;
  accessExpiresAtUtc: string | null;
  user: CurrentUser | null;
  isHydrating: boolean;
  setSession: (a: { accessToken: string; accessExpiresAtUtc: string; user: CurrentUser }) => void;
  clearSession: () => void;
  setHydrating: (b: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      accessExpiresAtUtc: null,
      user: null,
      isHydrating: true,
      setSession: ({ accessToken, accessExpiresAtUtc, user }) =>
        set({ accessToken, accessExpiresAtUtc, user, isHydrating: false }),
      clearSession: () => set({ accessToken: null, accessExpiresAtUtc: null, user: null, isHydrating: false }),
      setHydrating: (b) => set({ isHydrating: b }),
    }),
    {
      name: 'nhfb-admin-auth',
      partialize: (s) => ({ user: s.user }), // never persist token to localStorage
    },
  ),
);
